module.exports = __webpack_public_path__ + "static/media/POTS.dbe81713.png";